<template>
  <div class="product-list-filters">

    <div class="filters-wrapper">

      <div class="header d-flex justify-content-between align-middle">

        <h4 class="font-semibold mb-0">{{ __("filter") }}</h4>
        <i class="close lnr icon-cross" @click="$emit('hide_filters')"></i>

      </div>

      <div class="filters" v-if="uicontrol.ready">

        <div class="p-3 pb-0">
          <button class="btn btn-xs btn-secondary" @click="clearFilters()" v-if="selected_options.length">
            <i class="lnr icon-trash"></i> {{ __("remove_all_filters") }}
          </button>
        </div>

        <div class="price-filter-container" v-if="prices[0] !== prices[prices.length - 1]">

          <span class="filter-title d-inline-block">{{ __("price") }}</span>

          <Slider class="mt-5 mb-4" v-model="price_range" :min="prices[0]" :max="prices[prices.length - 1]" @change="changedPrice($event)" />

          <div class="d-flex justify-content-sm-between" v-if="uicontrol.prices_go_button.show">
            <span class="results_per_price">{{ results_count_for_price }} Rezultate</span>
            <button class="btn btn-secondary btn-sm mb-3" @click="go()" :disabled="results_count_for_price == 0">
              Filtreaza dupa pret
            </button>
          </div>

        </div>

        <div class="filters-attribute-container" v-if="attributes.length">
          <div class="filter-titles position-relative">
            <template v-for="attribute in attributes">
              <div class="filter-title" :dusk="'filter_attribute_' + attribute.translation.replaceAll(' ', '_')" :class="{ active : uicontrol.activeAttributeId === attribute.id }" @click="uicontrol.activeAttributeId = attribute.id">
                {{ attribute.translation }}
              </div>
            </template>
            <div class="position-absolute bottom-0">
              <div class="p-2 pb-3">
                <!--	OLD RESET FILTERS-->
              </div>
            </div>
          </div>

          <div class="filter-options-container">
            <div class="filter-options" v-for="attribute in attributes" :class="{'show' : uicontrol.activeAttributeId === attribute.id}">
              <component :is="(attribute.template + '_filter')" :attribute="attribute" :selected_options="selected_options" @addItem="addItem($event)" @removeItem="removeItem($event)"></component>
            </div>
          </div>
        </div>

        <div class="text-center mt-4" v-if="!attributes.length">
          <span class="filter-title d-inline-block mb-1"> {{ __("no_filters_available") }} </span>
        </div>

      </div>

      <div class="spinner-wrapper" v-else>
        <div class="spinner">
          <div class="bounce1"></div>
          <div class="bounce2"></div>
          <div class="bounce3"></div>
        </div>
      </div>

    </div>

    <div class="filters-background" @click="$emit('hide_filters')"></div>

    <div class="show_products px-3" @click="$emit('hide_filters')">
      <Button class="btn btn-primary w-100">
        {{__('show_count_products', { 'count' : $page.props.total_results })}}
      </Button>
    </div>

  </div>

</template>

<script type="module">

import Slider from "@/modules/@vueform/slider";
import checkboxes_filter from "./FilterTypes/CheckboxesFilter.vue";

export default {
  name: "Filters",
  data() {
    return {
      uicontrol: {
        ready: false,
        prices_go_button: {
          show: false
        },
        activeAttributeId: null
      },
      prices: [],
      price_range: [0, 0],
      route_params: route().params,
      attributes: null,
      selected_options: []
    };
  },
  components: {
    Slider,
    checkboxes_filter
  },
  props: {
    ignored_qs_parameters: {
      type: Array,
      default: () => []
    }
  },
  computed: {

    results_count_for_price() {
      return this.prices.filter(price => {
        return price >= this.price_range[0] && price <= this.price_range[1];
      }).length;
    }

  },

  mounted() {

    document.body.classList.add("noscroll");

    axios.post("/get-filter-data", {

      route_params: this.route_params

    }).then(response => {

      this.prices = response.data.prices;

      this.attributes = response.data.attributes;

      this.uicontrol.activeAttributeId = this.attributes[0]?.id || null;

      // Set min and max price possible
      this.price_range[0] = this.prices[0];
      this.price_range[1] = this.prices[this.prices.length - 1];

      // Set min and max price selected
      this.processQueryStringParams();
      this.processSelectedOptions();
      this.uicontrol.ready = true;

    });

  },

  beforeUnmount() {
    document.body.classList.remove("noscroll");
  },

  methods: {

    clearFilters() {
      // keep only slug from route_params
      const slug = this.route_params.slug;
      this.route_params = { slug };
      this.$emit('hide_filters');
      this.go();
    },

    /**
     * Attribute options that were selected (present in route params ) when Filters component was initialized
     * @param attribute_id
     * @returns {*[]|*}
     */
    processSelectedOptions(attribute) {

      // All option IDS in the url - get them by determining if the key is an integer. Other parameters such as min_price, max_price, page, etc. are not integers
      const optionIds = Object.values(this.route_params).filter(key => {
        return Number.isInteger(parseInt(key));
      });

      const optionIdsArray = !optionIds.length ? [] : optionIds.join(",").split(",").map(option => {
        return parseInt(option);
      });

      this.selected_options = optionIdsArray;

    },

    /**
     * Add attribute option to route params
     * @param attribute_id
     * @param option_id
     */
    addItem({ attribute_id, option_id }) {


      if (this.route_params[attribute_id] === undefined) {

        const optionIdString = option_id.toString();
        this.route_params[attribute_id] = optionIdString;

      } else {

        // If the attribute is in the route params, add the option to the attribute
        this.route_params[attribute_id] = this.route_params[attribute_id] + "," + option_id;

      }

      this.go();

    },

    /**
     * Remove attribute option from route params
     * @param attribute_id
     * @param option_id
     */
    removeItem({ attribute_id, option_id }) {

      const new_attribute_options = this.route_params[attribute_id].split(",").filter(option => {
        return option != option_id;
      });

      if (new_attribute_options.length === 0) {
        // If this is the last option of the attribute, remove the whole attribute
        delete this.route_params[attribute_id];
      } else {
        // If this is not the last option of the attribute, remove only the option
        this.route_params[attribute_id] = new_attribute_options.join(",");
      }

      this.go();

    },

    /**
     * Goes to new page based on route.params
     */
    go() {


      // PREVENT OLD OPTIONS FROM STAYING IN THE ROUTE PARAMS - start
      // EX. OLD URL WAS 2=3,6 , THEN AFTER APPLYING OTHER ATTRIBUTE FILTERS, 3 IS NO LONGER AN OPTION FOR ATTRIBUTE 2. So if we also remove 6, we don't want 2 to be in the route params with option 3 because that has no results. So we remove attribute 2 from the route params

      const allOptionIdsFromAttributesArray = this.attributes.map(attribute => {
        return attribute.options.map(option => {
          return option.id;
        });
      }).flat();

      // get selected options that are not in attributes array (old options)
      const selectedOptionsThatAreNotInAttributesArray = this.selected_options.filter(option => {
        return !allOptionIdsFromAttributesArray.includes(option);
      });

      // remove selected options that are not in attributes array from route params
      for (let option of selectedOptionsThatAreNotInAttributesArray) {
        for (let attribute_id in this.route_params) {

          // if attribute id in slug, min_price, max_price, etc. skip it
          if (!Number.isInteger(parseInt(attribute_id))) {
            continue;
          }

          const attribute_options = this.route_params[attribute_id].split(",");
          const new_attribute_options = attribute_options.filter(item => {
            return item != option;
          });

          if (new_attribute_options.length === 0) {
            delete this.route_params[attribute_id];
          } else {
            this.route_params[attribute_id] = new_attribute_options.join(",");
          }
        }
      }

      // PREVENT OLD OPTIONS FROM STAYING IN THE ROUTE PARAMS - end

      // Always go to page 1 after changing params
      delete this.route_params.p;

      // delete all ignored params
      this.route_params = Object.fromEntries(Object.entries(this.route_params).filter(([key, value]) => {
        return !this.ignored_qs_parameters.includes(key);
      }));

      let new_url = route("catchall", this.route_params);

      const decodedUrl = decodeURIComponent(new_url);
      const replacedUrl = decodedUrl.replace("%2C", ",");

      console.log("replacedUrl", replacedUrl);

      this.$inertia.get(replacedUrl);

    },

    /**
     * Process Query String Params
     */
    processQueryStringParams() {

      // Set min price in slider
      if (this.route_params.min_price)
        this.price_range[0] = parseInt(this.route_params.min_price);

      // Set max price in slider
      if (this.route_params.max_price)
        this.price_range[1] = parseInt(this.route_params.max_price);

    },

    /**
     * When slider changes the price range
     * @param new_price_range
     */
    changedPrice(new_price_range) {

      this.route_params.min_price = Math.floor(new_price_range[0]);
      this.route_params.max_price = Math.round(new_price_range[1]);
      this.uicontrol.prices_go_button.show = true;

    }


  }
};
</script>


<style src="@vueform/slider/themes/default.css"></style>

<style scoped>


</style>